import { render, staticRenderFns } from "./TeachSponsorsList.vue?vue&type=template&id=53277f3b&"
import script from "./TeachSponsorsList.vue?vue&type=script&lang=js&"
export * from "./TeachSponsorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports